// 根据英文文本自动生成 slug：转小写、去掉音调符号，非 a-z0-9 的片段折叠成单个短横线，
// 并去掉首尾短横线，与后端 Service 层的 SLUG_PATTERN（^[a-z0-9]+(-[a-z0-9]+)*$）保持一致。
export function slugify(text: string): string {
  return (text || '')
    .normalize('NFKD')
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

// slugify 结果为空时的兜底（比如管理员在"英文"标签页误填了非拉丁文字）：
// 用时间戳 + 随机片段拼一个必然合法的 slug，避免拦住用户没法提交。
export function generateFallbackSlug(): string {
  const time = Date.now().toString(36);
  const rand = Math.random().toString(36).slice(2, 8);
  return `faq-${time}${rand}`;
}

// 对应 swiftx-basic BasicMessageKey.DLCC_SLUG_ALREADY_EXISTS 的 key；
// GraphQLExceptionHandler 把 basic 侧 messageKey 原样透传为 error.message，
// 前端可以直接用这个常量字符串匹配，而不用猜测/匹配已翻译的文案。
export const SLUG_ALREADY_EXISTS_MESSAGE_KEY = 'errors.validation.basic.dlcc.slugAlreadyExists';

function isSlugConflictError(err: any): boolean {
  return Boolean(
    err?.graphQLErrors?.some(
      (e: any) => e?.message === SLUG_ALREADY_EXISTS_MESSAGE_KEY
        || e?.extensions?.message === SLUG_ALREADY_EXISTS_MESSAGE_KEY,
    ),
  );
}

const MAX_SLUG_RETRY_ATTEMPTS = 5;

// 用自动生成的 baseSlug 尝试创建；若后端因 slug 冲突拒绝，依次追加 -2、-3... 重试，
// 命中 MAX_SLUG_RETRY_ATTEMPTS 仍冲突则把最后一次的错误抛给调用方正常提示。
export async function createWithSlugRetry<T>(
  baseSlug: string,
  attemptFn: (slug: string) => Promise<T>,
  maxAttempts: number = MAX_SLUG_RETRY_ATTEMPTS,
): Promise<T> {
  let lastErr: any;
  for (let attempt = 1; attempt <= maxAttempts; attempt += 1) {
    const slug = attempt === 1 ? baseSlug : `${baseSlug}-${attempt}`;
    try {
      // eslint-disable-next-line no-await-in-loop
      return await attemptFn(slug);
    } catch (err) {
      lastErr = err;
      if (!isSlugConflictError(err)) throw err;
    }
  }
  throw lastErr;
}
